<template>
  <BuilderWrapper
    title="Marker for Points"
    helpful-tip="Customise the marker for point geometries"
  >
    <LabelledInput>
      <b-checkbox v-model="markerCustom">
        Use custom marker for geometry points
      </b-checkbox>
    </LabelledInput>

    <template v-if="markerCustom">
      <LabelledInput label="Marker style">
        <b-select
          v-model="markerIconName"
          :options="markerOptions"
        />
      </LabelledInput>

      <LabelledInput label="Marker size">
        <b-input-group>
          <b-input-group-text
            slot="prepend"
            class="prepend"
          >
            {{ markerSize }} %
          </b-input-group-text>
          <b-input
            v-model="markerSize"
            required
            type="number"
            min="0"
            step="5"
          />
        </b-input-group>
      </LabelledInput>
    </template>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { MAP_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  LabelledInput,
}

@Component({ components })
export default class CustomMarker extends Vue {
  markerOptions = [
    { value: 'map-marker', text: 'Marker' },
    { value: 'map-marker-alt', text: 'Marker Alternative' },
    { value: 'map-pin', text: 'Pin' },
  ]

  get markerIconName () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].markerIconName
  }

  set markerIconName (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'markerIconName'],
      value,
    })
  }

  get markerCustom () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].markerCustom
  }

  set markerCustom (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'markerCustom'],
      value,
    })
  }

  get markerSize () {
    return this.$typedStore.primary.app.config[MAP_CONFIG_KEY].markerSize
  }

  set markerSize (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, 'markerSize'],
      value,
    })
  }
}

</script>

<style scoped>
.prepend {
  width: 5rem;
}
</style>
